import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
	MATCH_VISIBLE,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, TYPE_DEFAULT_VALUE, TYPE_WORKFLOW_COMPONENT_OBSERVER, EXPRESSION_FIELD_SCOPE, FONCTION_WORKFLOW_COMPONENT_OPTIONS, SAGE_DOMAINES_OPTIONS, SAGE_DOMAINE, SAGE_TYPES_DOCUMENTS_OPTIONS, SAGE_TYPE_DOCUMENT } from 'src/app/app.models';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../../workflow-components.service';
  
export interface CommandGridInputModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE; 
	doDomaine: number;
	doType: number;
}
  
export class CommandGridInputModel extends DynamicInputModel {
	@serializable() readonly type: string = 'soudotec_command_gridinput';
	componentMode: COMPONENT_MODE;
	doDomaine: number;
	doType: number;
	constructor(config: CommandGridInputModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.doDomaine = config.doDomaine;
		this.doType = config.doType;
	}

	static initModel(_component: any): CommandGridInputModel {
		const formModel = new CommandGridInputModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
            additional: _component,
			relations: _component.RELATIONS,
			doDomaine: _component.DO_DOMAINE,
			doType: _component.DO_TYPE,
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		const workflowSteps = !!_options && !!_options.workflow ? _options.workflow.WORKFLOW_STEPS.map(step => ({ ID: step.NUM_WORKFLOWSTEP, TEXT: `${step.INDEX_WORKFLOWSTEP} - ${step.TITRE}` })) : [];
		const workflowComponents = !!_options && !!_options.workflow ? Array.prototype.concat.apply([], _options.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS.map(component => ({ ID: component.ID, TEXT: `${component.INDEX} - ${component.LABEL} [${component.CODE}]`, NUMWORKFLOW_STEP: step.NUM_WORKFLOWSTEP })))) : [];
		
		return {
			ID: 'soudotec_command_gridinput',
			CODE: CODE_WORKFLOW_COMPONENT.SOUDOTEC_COMMAND_GRIDINPUT,
			ICON: 'reader-outline',
			LABEL: 'Saisie de commandes',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, DEFAULT_VALUE: 'COMMANDE', CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
				{ ID: 'DO_DOMAINE', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Domaine *', DEFAULT_VALUE: SAGE_DOMAINE.VENTE, IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: SAGE_DOMAINES_OPTIONS,
							DATASOURCE_VALUE_FIELD: 'mVALUE_MEMBER',
							DATASOURCE_DISPLAY_FIELD: 'mDISPLAY_MEMBER'
						}
					}
				},
				{ ID: 'DO_TYPE', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Type Document *', DEFAULT_VALUE: SAGE_TYPE_DOCUMENT.VENTE_DEVIS, IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: SAGE_TYPES_DOCUMENTS_OPTIONS,
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'NAME'
						}
					}
				},
				{ ID: 'TYPE_DEFAULT_NUM_PIECE', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Type Num Piece', DEFAULT_VALUE: TYPE_DEFAULT_VALUE.CONSTANT, IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [
								{ ID: TYPE_DEFAULT_VALUE.CONSTANT, TEXT: 'Constante' }, 
								{ ID: TYPE_DEFAULT_VALUE.WORKFLOW_FIELD, TEXT: 'Champ du workflow' },
							],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					}
				},
				{ 
					ID: 'DEFAULT_NUM_PIECE', 
					CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, 
					LABEL: 'Num Pièce par défaut', 
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'TYPE_DEFAULT_NUM_PIECE', value: TYPE_DEFAULT_VALUE.CONSTANT }] }] 
				},
				{ 
					ID: 'DEFAULT_NUM_PIECE_NUMWORKFLOW_STEP', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Etape workflow', 
					IS_REQUIRED: true,
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: workflowSteps,
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					},
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'TYPE_DEFAULT_NUM_PIECE', value: TYPE_DEFAULT_VALUE.WORKFLOW_FIELD }] }] 
				},
				{ 
					ID: 'DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_ID', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Champ workflow', 
					IS_REQUIRED: true,
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'DEFAULT_NUM_PIECE_NUMWORKFLOW_STEP', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.FILTER_DATASOURCE, params: 'NUMWORKFLOW_STEP' }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: workflowComponents,
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					},
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'TYPE_DEFAULT_NUM_PIECE', value: TYPE_DEFAULT_VALUE.WORKFLOW_FIELD }] }] 
				},
				{ 
					ID: 'DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_PROPERTY', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Propriété', 
					IS_VISIBLE: false,
					CONDITIONS_VISIBILITY: { condition: 'and', rules: [
						{ field: 'DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_ID', operator: 'eq', scope: EXPRESSION_FIELD_SCOPE.WORKFLOW_COMPONENT_METADATA, value: CODE_WORKFLOW_COMPONENT.DROPDOWN, datasource_column: 'CODE' },
						{ field: 'TYPE_DEFAULT_NUM_PIECE', operator: 'eq', scope: EXPRESSION_FIELD_SCOPE.CONSTANT, value: TYPE_DEFAULT_VALUE.WORKFLOW_FIELD }
					]},
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_ID', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.ASSIGN_WORKFLOW_COMPONENT_DATAS, params: 'DS_COLUMNS' }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					},
				},
			]
		};
	}
}
  